import { on, createReducer } from '@ngrx/store';
import { searchLocations, searchLocationsSuccess } from './location.actions';
import { StoreState } from '../../enums/store-state';
import { TadLocation } from 'src/generated/graphql';

export const locationFeatureKey = 'locationFeatureKey';

export interface LocationState {
  locationState: StoreState;
  locations: TadLocation[];
}

export const initialState: LocationState = {
  locationState: StoreState.idle,
  locations: [],
};

export const locationReducer = createReducer(
  initialState,

  on(searchLocations, (state) => ({
    ...state,
    locationState: StoreState.inProgress,
    locations: [],
  })),
  on(searchLocationsSuccess, (state, data) => ({
    ...state,
    locationState: StoreState.success,
    locations: data.locations,
  }))
);
